import { render, staticRenderFns } from "./SearchPopup.vue?vue&type=template&id=4a778c90&scoped=true"
import script from "./SearchPopup.vue?vue&type=script&lang=ts"
export * from "./SearchPopup.vue?vue&type=script&lang=ts"
import style0 from "./SearchPopup.vue?vue&type=style&index=0&id=4a778c90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a778c90",
  null
  
)

export default component.exports